/* import __COLOCATED_TEMPLATE__ from './translations-csv.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class TranslationsCSVComponent extends Component 
{
	@service store;
	@service csv;
	
	@action
	async downloadCSV()
	{
		var data = [];
		var headers = ['chip','bib','lot','name','startTime','endTime','backup'];

		data.push(headers);

		const translations = await this.store.findAll('Translation');

		for(const translation of translations)
		{
			const startTime = translation.startTime || '';
			const endTime = translation.endTime || '';
			const backup = translation.isBackup ? 'true' : 'false';
			data.push([translation.chip,translation.bib,translation.lot,translation.name,startTime,endTime,backup]);
		}
		this.csv.export(data, {fileName:'translations.csv',withSeparator:false});
	}
};